import * as React from 'react';
import Project from 'src/entities/Project';
import ConfirmProfileContainer from './partials/confirm-profile/ConfirmProfile.container';
import Investment from 'src/entities/Investment';
import ConfirmImportContainer from './partials/confirm-import/ConfirmImport.container';
import Person from 'src/entities/Person';
import WritingContractsContainer from './partials/writing-contracts/WritingContracts.container';
import ReviewContractsContainer
  from 'src/modules/project/partials/project-formalization/partials/review-contracts/ReviewContracts.container';
import ProjectFormalizationHeaderComponent
  from 'src/modules/project/partials/project-formalization/partials/ProjectFormalizationHeader.component';
import ResultPageCardComponent from 'src/modules/commons/result-page/ResultPageCard.Component';
import SignContractsComponent
  from 'src/modules/project/partials/project-formalization/partials/sign-contracts/SignContracts.component';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import ResultPageComponent from 'src/modules/commons/result-page/ResultPage.Component';

export interface ProjectFormalizationComponentProps {
  investment: Investment;
  person: Person;
  project: Project;
  step: string;
  formalizationIsLoading: boolean;
  activePayment: boolean;
  handleChangeTab: (value: string) => void;

  setStep(step: string): void;

  setInvestment(investment: Investment, step: string): void;
}

const ProjectFormalizationComponent: React.StatelessComponent<ProjectFormalizationComponentProps> = (
  props: ProjectFormalizationComponentProps
) => {
  function showContent(): React.ReactNode {
    switch (props.step) {
      case 'Reviewing Profile':
        return (
          <ConfirmProfileContainer
            setStep={props.setStep}
            person={props.person}
            projectId={props.project.id!}
            investment={props.investment}
            setInvestment={props.setInvestment}
          />
        );
      case 'Confirmed Profile':
        return (
          <ConfirmImportContainer
            investment={props.investment}
            setInvestment={props.setInvestment}
          />
        );
      case 'Confirmed Amount':
        return (
          <WritingContractsContainer
            investment={props.investment}
            setInvestment={props.setInvestment}
          />
        );
      case 'Reviewing Amount Change':
        return (
          <div>
            <div className="gap-20"/>
            <ResultPageCardComponent
              title="Aún no puedes acceder"
              message="El equipo de soporte al inversor está validando tu petición"
              success={false}
            />
          </div>
        );
      case 'Reviewing Contracts':
        return (
          <ReviewContractsContainer
            project={props.project}
            investment={props.investment!}
            setInvestment={props.setInvestment}
          />
        );
      case 'Reviewing Contracts Correction':
        return (
          <ResultPageCardComponent
            title="Gracias por comunicarnos la errata."
            message="el equipo de soporte al inversor revisará tu caso y te informaremos de los cambios."
            success={true}
          />
        );
      case 'Accepted Contracts':
        if (props.project.formalizationStatus === 'Firmando contratos') {
          return (
            <SignContractsComponent
              project={props.project}
              investment={props.investment!}
            />
          );
        } else {
          return (
            <ResultPageComponent
              title={'Gracias por confirmar tus datos en los contratos de ' + props.project.company.name}
              message={'Una vez que tengamos los contratos disponibles para firmar te notificaremos para que procedas' +
              ' a la firma de los mismos.'}
              success={true}
            />
          );
        }

      case 'Signed Contracts':
        if (!props.activePayment) {
          return (
            <ResultPageComponent
              title={'Gracias por seguir todos los pasos para formalizar ' + props.project.company.name}
              message={'Una vez tengamos todas las firmas y desembolsos, los abogados de la operación' +
              ' continuarán con la elevación a público de la operación y en un plazo de un mes posterior a la ' +
              'elevación os dejaremos a vuestra disposición la escritura en los documentos de la operación.'}
              success={true}
            />
          );
        } else {
          return (
            <div className="text-center margin-l-r-60 padding-l-r-40">
              <div className="gap-20"/>
              <span className="corrected-circle"/>
              <div className="gap-10"/>
              <p>
                <strong>
                  Gracias por seguir todos los pasos para formalizar {props.project.company.name} ahora puedes proceder
                  a demembolsar {NumberFormater.euros(
                  (1.21 * 0.02 + 1) * props.investment.amountInvested
                )}
                </strong>
              </p>
              <div className="gap-10"/>
              <button
                className="btn btn-secondary"
                onClick={() => props.handleChangeTab('payment')}
              >
                Proceder a desembolso
              </button>
            </div>
          );
        }
      default:
        return null;
    }

  }

  return (
    <div className="col-sm-9">
      <div className="padding-left-30">
        <div className="gap-50"/>

        <h3>
          Formalizar Operación
        </h3>
        <div className="gap-20"/>
        {props.step === 'Reviewing Amount Change' ?
          <ProjectFormalizationHeaderComponent step="Confirmed Profile"/> :
          (props.step === 'Reviewing Contracts Correction' ?
            <ProjectFormalizationHeaderComponent step="Reviewing Contracts"/> :
            <ProjectFormalizationHeaderComponent step={props.step}/>)
        }

        <div className="row">
          {
            showContent()
          }
        </div>
        <div className="gap-50"/>
      </div>
    </div>
  );
};

export default ProjectFormalizationComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/ProjectFormalization.component.tsx